import { ValueChangeDetails } from '@zag-js/select'
import { TbChevronDown } from 'react-icons/tb'

import { createListCollection, Select as SelectUiKit } from 'ui-kit/select'

import { Item, LoadingItem, ValueText } from './chunks'
import { SelectItemType, SelectProps } from './types'

export function Select({
  label,
  placeholder,
  items,
  value,
  onValueChange,
  loading,
  positioning = {
    hideWhenDetached: true,
    sameWidth: true,
    strategy: 'fixed',
  },
  IndicatorIconComponent = <TbChevronDown />,
  TriggerTextComponent,
  ItemTextComponent,
  ...props
}: SelectProps) {
  const collection = createListCollection({ items })
  const selectedValue = value ? [value.value] : undefined

  function handleValueChange({ items }: ValueChangeDetails<SelectItemType>) {
    onValueChange?.(items?.[0])
  }

  return (
    <SelectUiKit.Root
      lazyMount
      unmountOnExit
      collection={collection}
      value={selectedValue}
      onValueChange={handleValueChange}
      positioning={positioning}
      {...props}
    >
      {!!label && <SelectUiKit.Label>{label}</SelectUiKit.Label>}
      <SelectUiKit.Control>
        <SelectUiKit.Trigger>
          <ValueText
            TriggerTextComponent={TriggerTextComponent}
            ItemTextComponent={ItemTextComponent}
            value={value}
            placeholder={placeholder}
          />
          {IndicatorIconComponent}
        </SelectUiKit.Trigger>
      </SelectUiKit.Control>
      <SelectUiKit.Positioner>
        <SelectUiKit.Content>
          <SelectUiKit.ItemGroup>
            {loading && <LoadingItem />}
            {collection.items.map((item) => (
              <Item
                ItemTextComponent={ItemTextComponent}
                item={item}
                key={item.value}
              />
            ))}
          </SelectUiKit.ItemGroup>
        </SelectUiKit.Content>
      </SelectUiKit.Positioner>
      <SelectUiKit.HiddenSelect />
    </SelectUiKit.Root>
  )
}
